/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
==========================================================================================*/

export default [
  {
    url: null,
    name: "asdf",
    userMenu: true,
    slug: "member",
    icon: "UserIcon",
    levelUp: '0',
    levelDw: '12',
    submenu: [
      {
        url: '/pages/logout',
        name: "로그아웃",
        slug: "logout",
      },
    ]
  },
  {
    url: "/WriteArticles",
    name: "기사작성",
    slug: "writearticles",
    icon: "CreditCardIcon",
    levelUp: '2',
    levelDw: '12',
  },
  {
    // 통신사 수신함. 기사작성 참고용이라 기자 권한으로 연다.
    url: "/wireList",
    name: "연합뉴스",
    slug: "wirelist",
    icon: "RssIcon",
    levelUp: '2',
    levelDw: '12',
  },
  {
    url: "/newsListDeleted",
    name: "삭제뉴스",
    slug: "newsListDeleted",
    icon: "ListIcon",
    levelUp: '10',
    levelDw: '12',
  },
  {
    url: "/newsList",
    name: "뉴스리스트",
    slug: "newslist",
    icon: "ListIcon",
    levelUp: '2',
    levelDw: '12',
    submenu: [
      {
        url: '/newsListAll?department=all',
        name: '전체',
        slug: "newslist",
      },
      // 부서 필터는 기사 작성자(article.mno)의 현재 소속(member.option1)으로 건다.
      // 코드는 store/state.js 의 departmentOption / 기자관리 부서 드롭다운과 같은 것을 쓴다.
      // 데일리안 편제(g3 산업·g13 국제·g14~g17 팀)는 중앙신문에 소속자가 없어 뺐다.
      {
        url: '/newsListAll?department=g12',
        name: '경기본부',
        slug: "newslist_g12",
      },
      {
        url: '/newsListAll?department=g18',
        name: '인천본부',
        slug: "newslist_g18",
      },
      {
        url: '/newsListAll?department=desk',
        name: '편집국',
        slug: "newslist_desk",
      },
      {
        url: '/newsListAll?department=g1',
        name: '정치부',
        slug: "newslist_g1",
      },
      {
        url: '/newsListAll?department=g10',
        name: '사회부',
        slug: "newslist_g10",
      },
      // 🔴 아래 넷은 **부서가 아니라 묶음(표시용 제목)** 이다.
      //    『중앙신문_CMS_수정안_260922』 3번이 뉴스리스트를 이렇게 묶어 달라고 했다.
      //    산업/ICT융합부·금융증권부·생활경제부·연예스포츠부라는 부서는 **존재하지 않는다**
      //    (2026-09-24 확인). 그래서 url 을 주지 않는다 — 펼치기만 하고 이동하지 않는다.
      //    실제 필터는 그 아래 개별 부서 코드(member.option1)로만 건다. 부서 체계는 그대로다.
      {
        name: '산업/ICT융합부',
        slug: "newslist_grp_industry",
        submenu: [
          { url: '/newsListAll?department=g20', name: '산업부',    slug: "newslist_g20" },
          { url: '/newsListAll?department=g21', name: 'ICT융합부', slug: "newslist_g21" },
        ],
      },
      {
        name: '금융증권부',
        slug: "newslist_grp_finance",
        submenu: [
          { url: '/newsListAll?department=g22', name: '금융부', slug: "newslist_g22" },
          { url: '/newsListAll?department=g23', name: '증권부', slug: "newslist_g23" },
        ],
      },
      {
        name: '생활경제부',
        slug: "newslist_grp_life",
        submenu: [
          { url: '/newsListAll?department=g24', name: '건설부동산부', slug: "newslist_g24" },
          { url: '/newsListAll?department=g25', name: '유통부',      slug: "newslist_g25" },
        ],
      },
      {
        // 2026-09-24 에 부서를 실제로 쪼갰다 — g26 연예부 / g28 스포츠부.
        name: '연예스포츠부',
        slug: "newslist_grp_ent",
        submenu: [
          { url: '/newsListAll?department=g26', name: '연예부',   slug: "newslist_g26" },
          { url: '/newsListAll?department=g28', name: '스포츠부', slug: "newslist_g28" },
        ],
      },
      {
        // 기자 배정 목록(store/state.js)에는 있는데 이 사이드바에만 빠져 있었다
        // (2026-09-28). 배정 인원이 0명이어도 메뉴에는 있어야 한다 — g26/g28 도 같다.
        url: '/newsListAll?department=g27',
        name: '국제부',
        slug: "newslist_g27",
      },
      {
        url: '/newsListAll?department=g9',
        name: '뉴미디어부',
        slug: "newslist_g9",
      },
      {
        url: '/newsListAll?department=g8',
        name: '사진부',
        slug: "newslist_g8",
      },
      {
        url: '/newsListAll?department=g0',
        name: '미분류',
        slug: "newslist_g0",
      },
      // 아래 둘은 부서가 아니라 카테고리(section)로 거른다.
      {
        url: '/newsListAll?department=pr',
        name: 'PR',
        slug: "newslist_pr",
      },
      {
        url: '/newsListAll?department=ad119',
        name: '보도자료',
        slug: "newslist_ad119",
      },
    ]
  },
  {
    url: "/photoArticle",
    name: "기사사진",
    slug: "articlePhotos",
    icon: "GridIcon",
    levelUp: '2',
    levelDw: '12',
  },
  {
    url: "/NewsPlace",
    name: "뉴스배치",
    slug: "newsplace",
    icon: "LayoutIcon",
    // 🔴 **데스크(9) 이상만.** 2026-10-07 요청으로 8 → 9 로 올렸다.
    //    서버도 같이 막았다(app.js 의 `/api/newsPlace` → check_9_12).
    //    ⚠ 한쪽만 고치면 "메뉴는 보이는데 401" 이거나 그 반대가 된다.
    levelUp: '9',
    levelDw: '12',
    submenu: [
      {
        url: '/NewsPlace?category=0',
        name: '홈페이지 배치',
        slug: "newsplace",
        permission: "mainBatch"
      },
      // 네이버(77)·다음(78) 배치는 데일리안 제휴 전용이라 뺐다.
      // 중앙신문은 아직 포털 제휴가 없다. 제휴가 생기면 이 항목과
      // newsPlace.js 의 PORTAL_SYNC_ENABLED 를 같이 되살린다.
      {
        url: '/NewsPlace?category=1',
        name: '정치 배치',
        slug: "newsplace_1",
      },
      {
        url: '/NewsPlace?category=2',
        name: '경제 배치',
        slug: "newsplace_2",
      },
      {
        url: '/NewsPlace?category=3',
        name: '사회 배치',
        slug: "newsplace_3",
      },
      {
        url: '/NewsPlace?category=4',
        name: '인천 배치',
        slug: "newsplace_4",
      },
      {
        url: '/NewsPlace?category=5',
        name: '지역 배치',
        slug: "newsplace_5",
      },
      {
        url: '/NewsPlace?category=6',
        name: '생활·문화 배치',
        slug: "newsplace_6",
      },
      {
        url: '/NewsPlace?category=7',
        name: 'IT·과학 배치',
        slug: "newsplace_7",
      },
      {
        // S1N8. 2026-09-05 에 '세계' → '글로벌' 로 이름을 바꿨다(section.name 도 함께).
        // url 의 category=8 과 슬러그는 그대로다 — 링크가 깨지지 않게.
        url: '/NewsPlace?category=8',
        name: '글로벌 배치',
        slug: "newsplace_8",
      },
      {
        url: '/NewsPlace?category=9',
        name: '스포츠 배치',
        slug: "newsplace_9",
      },
      {
        url: '/NewsPlace?category=10',
        name: '오피니언 배치',
        slug: "newsplace_10",
      },
      {
        url: '/NewsPlace?category=11',
        name: '포토 배치',
        slug: "newsplace_11",
      },
      {
        url: '/NewsPlace?category=12',
        name: '지역포커스 배치',
        slug: "newsplace_12",
      },
      {
        url: '/NewsPlace?category=13',
        name: '보도자료 배치',
        slug: "newsplace_13",
      },
      {
        url: '/NewsPlace?category=14',
        name: '카드뉴스 배치',
        slug: "newsplace_14",
      },
      {
        url: '/NewsPlace?category=15',
        name: 'PR 배치',
        slug: "newsplace_15",
      },
      {
        url: '/NewsPlace?category=16',
        name: '연예 배치',
        slug: "newsplace_16",
      },
    ]
  },
  {
    url: null,
    name: "게시판",
    slug: "board",
    icon: "FileTextIcon",
    levelUp: '4',
    levelDw: '12',
    submenu: [
      // 2026-09-01 게시판 카테고리 정리 (중앙신문 CMS 수정사항_260831 5번)
      //  - 삭제 10개(광고안내·저작권문의·구독신청·불편신고·제휴안내·독자마당·알림·부고·행사·결혼)는
      //    메뉴에서만 뺐다. board/board_post 데이터는 보존(되돌릴 수 있음).
      //  - 유지: 기사제보(2)·독자투고(7). 신설: 현장보고(13)·편집회의(14)·사내게시판(15)·정보보고(16).
      //  - 휴가신청은 결재 흐름이 있어 별도 화면(/leaveRequest).
      //  - 데일리안 정보보고는 이상준(bm2112) 로그인 시에만 노출.
      {
        url: '/board?tbcode=2',
        name: "기사제보",
        slug: "bd_2",
      },
      {
        url: '/board?tbcode=7',
        name: "독자투고",
        slug: "bd_7",
      },
      {
        url: '/board?tbcode=13',
        name: "현장보고",
        slug: "bd_13",
      },
      {
        url: '/board?tbcode=14',
        name: "편집회의",
        slug: "bd_14",
      },
      {
        url: '/board?tbcode=15',
        name: "사내게시판",
        slug: "bd_15",
      },
      {
        url: '/board?tbcode=16',
        name: "정보보고",
        slug: "bd_16",
      },
      {
        url: '/leaveRequest',
        name: "휴가신청",
        slug: "leaveRequest",
      },
      {
        // 연차 통계 · 사용촉진(근로기준법 제61조).
        // 데이터는 데스크(level>=8) 이상만 온다 — 서버가 확인한다.
        url: '/leaveStats',
        name: "연차통계",
        slug: "leaveStats",
      },
      {
        // 데일리안 newetc DB 의 정보보고를 **열람만** 하는 화면(board.js).
        // loginId 는 쉼표로 여러 명을 넣을 수 있다(VxSidebarGroup.vue 에서 split).
        //   bm2112  이상준(desk) — 2026-10-06 현재 이 한 명뿐이다.
        // 🔴 **서버도 같이 막는다 (2026-10-06).** 전에는 여기서 메뉴를 가리는 것뿐이라
        //    URL 을 직접 치면 누구나 봤다. 지금은 app.js 의 `dailianInfoGate` 가
        //    `/api/board` 의 게시글 계열 경로를 login_id 로 거른다.
        //    ⚠ **명단을 바꿀 때 두 곳을 같이 고쳐야 한다** — 여기(메뉴)와
        //      서버의 `DAILIAN_BOARD_USERS`(기본값 'bm2112', PM2 env 로 덮을 수 있다).
        //      한쪽만 고치면 "메뉴는 보이는데 403" 이거나 그 반대가 된다.
        url: '/board?tbcode=102&src=dailian',
        name: "데일리안 정보보고",
        slug: "bd_dailian_info",
        loginId: 'bm2112',
      },
    ]
  },
  {
    name: "통계",
    slug: "statistics",
    icon: "PieChartIcon",
    // 일반기자(7·8)는 통계 메뉴를 표시하지 않는다. 데스크(9) 이상만 표시.
    levelUp: '9',
    levelDw: '12',
    submenu: [
      {
        // 기자 본인 기사 통계. 화면(StatisticsDescMyOwn.vue)과 API(/api/statistics/myOwn,
        // check_2_10)는 처음부터 있었는데 **메뉴 링크가 없어 도달할 수 없었다**(2026-09-15 연결).
        url: '/statistics/myOwn',
        name: "내 기사",
        slug: "statisticsMyOwn",
      },
      {
        url: '/statistics/desc',
        name: "조회수 순",
        slug: "statisticsDesc",
      },
      {
        url: '/statistics/eachReporter',
        name: "작성자별",
        slug: "statisticsEachReporter",
      },
      {
        url: '/statistics/days',
        name: "날짜 별",
        slug: "statisticsDays",
      },
      {
        url: '/statistics/month',
        name: "월 별",
        slug: "statisticsMonth",
      },
    ]
  },
  {
    name: "배너",
    slug: "adBanners",
    icon: "LayoutIcon",
    levelUp: '10',
    levelDw: '12',
    // permission: "banner" 는 뺐다 — member.permission 이 NULL 인 관리자(jasm)에게
    // 메뉴가 안 보였다. API 는 check_8_10 이라 레벨만으로 충분하다.
    submenu: [
      {
        url: '/ad/article',
        name: "기사면",
        slug: "adArticle",
      },
      {
        url: '/ad/home',
        name: "메인홈",
        slug: "adHome",
      },
      {
        url: '/ad/list',
        name: "목록면",
        slug: "adList",
      },
      {
        url: '/ad/common',
        name: "공통 (전 페이지)",
        slug: "adCommon",
      },
    ]
  },
  {
    url: null,
    name: "회원관리",
    slug: "member",
    icon: "UserIcon",
    levelUp: '10',
    levelDw: '12',
    submenu: [
      {
        url: '/member/reporter?deleted=',
        name: "기자 관리",
        slug: "memberReporter",
      },
      {
        url: '/member/reporter?deleted=true',
        name: "퇴사자 관리",
        slug: "memberDeleted",
      },
      {
        // member 한 테이블을 level 로 가른다 — 1=일반회원 / 3~11=기자·관리자.
        // 기자/퇴사자 관리는 level>=3, 이 화면은 level<3 을 본다.
        url: '/member/common',
        name: "일반회원 관리",
        slug: "memberCommon",
      },
    ]
  },
  {
    url: "/Setting",
    name: "설정",
    slug: "setting",
    icon: "SettingsIcon",
    levelUp: '10',
    levelDw: '12',
    permission: "setting"
  },
]
